import { notificationsForm } from "./notifications-form";

export interface PopoverListenerOptions {
    triggerEl: HTMLElement;
    popoverEl: HTMLElement;
    onToggle?: () => Promise<void> | void;
    onClose?: () => void;
}

export function bindPopoverListeners({ triggerEl, popoverEl, onToggle, onClose }: PopoverListenerOptions): () => void {
    if (!(triggerEl instanceof HTMLElement)) return () => {};
    if (!(popoverEl instanceof HTMLElement)) return () => {};

    const onTriggerClick = async (event: Event): Promise<void> => {
        if (event?.target instanceof Node && popoverEl.contains(event.target)) return;
        event.preventDefault();
        event.stopPropagation();
        await onToggle?.();
    };

    const onDocClick = (event: Event): void => {
        if (!popoverEl || popoverEl.hidden) return;
        if (!(event.target instanceof Node)) return;
        if (triggerEl.contains(event.target)) return;
        onClose?.();
    };

    const onKeyDown = (event: Event): void => {
        if (!popoverEl || popoverEl.hidden) return;
        if (event instanceof KeyboardEvent && event.key === "Escape") onClose?.();
    };

    const closeBtn = notificationsForm.getCloseButton(popoverEl);
    const onCloseClick = (event: Event): void => {
        event.preventDefault();
        event.stopPropagation();
        onClose?.();
    };

    triggerEl.addEventListener("click", onTriggerClick);
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKeyDown);
    if (closeBtn instanceof HTMLElement) closeBtn.addEventListener("click", onCloseClick);

    return (): void => {
        triggerEl.removeEventListener("click", onTriggerClick);
        document.removeEventListener("click", onDocClick);
        document.removeEventListener("keydown", onKeyDown);
        if (closeBtn instanceof HTMLElement) closeBtn.removeEventListener("click", onCloseClick);
    };
}

export function bindNotificationItemActivation(
    itemEl: HTMLElement,
    activate: (event: Event) => void,
    onKeyDown: (event: Event) => void,
): void {
    itemEl.addEventListener("click", activate);
    itemEl.addEventListener("keydown", onKeyDown);
}
